<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Bulk Copy with Data Replacement</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-alert type="info" dense text>
                Selected items will be copied and all occurrences of the search value will be replaced with the replace value.
              </v-alert>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="searchValue"
                label="Search"
                outlined
                dense
                hint="Value to search for in the copied items"
                persistent-hint
                :error-messages="searchError"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="replaceValue"
                label="Replace"
                outlined
                dense
                hint="Value to replace with"
                persistent-hint
                :error-messages="replaceError"
              />
            </v-col>
          </v-row>

          <v-row v-if="selectedCount > 0">
            <v-col cols="12">
              <v-alert type="warning" dense text>
                {{ selectedCount }} item(s) selected for bulk copy
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="grey" text @click="cancel">Cancel</v-btn>
        <v-btn color="primary" @click="apply" :disabled="!isValid" :loading="loading">Apply</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "r-bulk-copy-dialog",

  data: () => ({
    dialog: false,
    searchValue: "",
    replaceValue: "",
    selectedCount: 0,
    loading: false,
    searchError: "",
    replaceError: "",
    resolve: null,
    reject: null
  }),

  computed: {
    isValid() {
      return this.searchValue && this.replaceValue && this.searchValue !== this.replaceValue;
    }
  },

  methods: {
    show(selectedCount) {
      this.dialog = true;
      this.selectedCount = selectedCount;
      this.searchValue = "";
      this.replaceValue = "";
      this.searchError = "";
      this.replaceError = "";
      this.loading = false;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    apply() {
      this.searchError = "";
      this.replaceError = "";

      if (!this.searchValue) {
        this.searchError = "Search value is required";
        return;
      }

      if (!this.replaceValue) {
        this.replaceError = "Replace value is required";
        return;
      }

      if (this.searchValue === this.replaceValue) {
        this.searchError = "Search and replace values must be different";
        return;
      }

      this.dialog = false;
      this.resolve({
        search: this.searchValue,
        replace: this.replaceValue
      });
    },

    cancel() {
      this.dialog = false;
      this.reject(new Error("Cancelled"));
    }
  }
};
</script>
